<template>
  <div class="hello">
    <h1>Login</h1>
    <div class="description text-secondary mb-3">Teospa-app login page.</div>
    <TeoLogin />
    <TeoInfo />
  </div>
</template>

<script>
import TeoInfo from "../TeoInfo.vue";
import TeoLogin from "../TeoLogin.vue";

export default {
  name: "PageHome",
  components: {
    TeoInfo,
    TeoLogin,
  },

  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
